import { render, staticRenderFns } from "./CustomerState.vue?vue&type=template&id=68df6201"
import script from "./CustomerState.vue?vue&type=script&lang=js"
export * from "./CustomerState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports